module.exports = function() {
  return new Worker(__webpack_public_path__ + "33d7d4c21be6f7ff.worker.js");
};